import { FRONTEND_PRESS_PROFILE_FEED_PATH, INFRASTRUCTURE_PROJECTS_PARTIAL } from 'src/constants/urls'

export interface IWhitelabelRedirect {
  // absolute path that should no longer render its own page
  from: string;
  // absolute path to redirect to
  to: string;
}

// Instance specific redirects, fixed at build time. They take precedence over every other route,
// so only the exact paths listed here are affected — everything else routes as usual.
//
// `from` is built from the same constant the author link uses, so the two are character for
// character the same path.
//
// Profile slug and project slug are listed separately although they are equal today: that is a
// property of the data, not of the schema. A profile that is renamed gets a new slug and loses
// its redirect; a project keeps its slug.
const pressProfileToProject = (profileSlug: string, projectSlug: string): IWhitelabelRedirect => ({
  from: `${FRONTEND_PRESS_PROFILE_FEED_PATH}${profileSlug}`,
  to: `${INFRASTRUCTURE_PROJECTS_PARTIAL}/${projectSlug}`
})

export const WHITELABEL_REDIRECTS: IWhitelabelRedirect[] = [
  pressProfileToProject(
    'a-100-a-115-umbau-des-autobahndreiecks-funkturm',
    'a-100-a-115-umbau-des-autobahndreiecks-funkturm'
  ),
  pressProfileToProject('a-100-ersatzneubau-der-ringbahnbrucke', 'a-100-ersatzneubau-der-ringbahnbrucke'),
  pressProfileToProject('a-100-ersatzneubau-der-rudolf-wissell-brucke', 'a-100-ersatzneubau-der-rudolf-wissell-brucke'),
  pressProfileToProject('a-100-ersatzneubau-der-westendbrucke', 'a-100-ersatzneubau-der-westendbrucke'),
  pressProfileToProject('a-111-grundsanierung', 'a-111-grundsanierung')
]
